import { Component } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ConfigProvider } from "antd";
import Auth from "./pages/Auth/Auth";
import OrganizationSelect from "./pages/OrganizationSelect/OrganizationSelect";
import OrganizationDashboard from "./pages/OrganizationDashboard/OrganizationDashboard";
import BrickCollection from "./pages/BrickCollection/BrickCollection";

export default class App extends Component {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {
    // console.log(getSession())
  }

  render() {
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#1890ff', // Default Ant Design primary color
          },
        }}
      >
        <Router>
          <Routes>
            <Route path="/login" element={<Auth />} />
            <Route path="/" element={<OrganizationSelect />} />
            <Route path="/:organizationId" element={<OrganizationDashboard />} />
            <Route
              path="/:organizationId/collections/:collectionId"
              element={<BrickCollection />}
            />
          </Routes>
        </Router>
      </ConfigProvider>
    );
  }
}
